var render = function render(_c,_vm){return _vm._m(0)
}
var staticRenderFns = [function (_c,_vm){return _c('div',{staticClass:"sf-spinner"},[_c('div',{staticClass:"sf-spinner__inner"},[_c('div',{staticClass:"sf-spinner__gap"}),_c('div',{staticClass:"sf-spinner__left"},[_c('div',{staticClass:"sf-spinner__half-circle"})]),_c('div',{staticClass:"sf-spinner__right"},[_c('div',{staticClass:"sf-spinner__half-circle"})])])])
}]

export { render, staticRenderFns }